import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle, Checkbox, Input } from 'web/src/app/root/components/common'
import { useSelector } from 'react-redux'

import { getComponents, getInitialRoleState } from './utils'
import { Table } from 'web/src/app/root/components/common/table'
import { SIDEBAR_MENU_NAMES } from 'web/src/app/root/constants'
import { useEffect } from 'react'

export const CreateRole = ({
    roleState,
    setRoleState,
    name,
    setName,
    error
}) => {
    const styles = useStyles()
    const { locale, user } = useSelector(state => state.main)

    const columns = useMemo(() => getColums(locale), [locale])
    const components = useMemo(
        () => getComponents(roleState, user),
        [roleState, user]
    )

    const onPermissionToggle = (value, component, permission) => {
        setRoleState(prevState => {
            const newState = { ...prevState }
            newState[component][permission] = value
            return newState
        })
    }

    const tableCustomRenderer = ({ rowData, columnKey }) => {
        switch (columnKey) {
            case 'component':
                return <span>{SIDEBAR_MENU_NAMES(locale)[rowData]}</span>
            default:
                return (
                    <Checkbox
                        className={styles.checkboxFix}
                        onClick={(_, value) =>
                            onPermissionToggle(value, rowData, columnKey)
                        }
                        checked={roleState[rowData][columnKey]}
                    />
                )
        }
    }

    useEffect(() => {
        if (!Object.keys(roleState).length) {
            setRoleState(getInitialRoleState(user))
        }
    }, [user])

    return (
        <div className={styles.wrapper}>
            <PageTitle
                position={'center'}
                title={locale.userManagement.createRoleStepTitle}
                className={styles.title}
            />

            <div>
                <Input
                    className={styles.nameInput}
                    label={locale.userManagement.roleName}
                    type="text"
                    errorText={locale.common.required}
                    isError={error}
                    setValue={setName}
                    value={name}
                />
            </div>
            <Table
                rows={components}
                columns={columns}
                customRenderer={tableCustomRenderer}
            />
        </div>
    )
}

const getColums = locale => [
    {
        key: 'component',
        label: locale.userManagement.component,
        sortable: false,
        dataType: 'string',
        useCustomRenderer: true
    },
    {
        key: 'create',
        label: locale.userManagement.create,
        sortable: false,
        dataType: 'boolean',
        useCustomRenderer: true
    },
    {
        key: 'read',
        label: locale.userManagement.read,
        sortable: false,
        dataType: 'boolean',
        useCustomRenderer: true
    },
    {
        key: 'update',
        label: locale.userManagement.update,
        sortable: false,
        dataType: 'boolean',
        useCustomRenderer: true
    },
    {
        key: 'delete',
        label: locale.userManagement.delete,
        sortable: false,
        dataType: 'boolean',
        useCustomRenderer: true
    }
]
const useStyles = makeStyles(theme => ({
    title: {
        marginBottom: 32
    },
    link: {
        color: theme.textPrimary,
        textDecoration: 'none',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    nameInput: {
        width: 340,
        marginBottom: 20
    },
    checkboxFix: {
        marginLeft: '0 !important'
    }
}))
